import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import RegisterParticipant from "@/pages/RegisterParticipant";
import EventDetails from "@/pages/EventDetails";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CrewLogin from "@/pages/CrewLogin";
import CrewDashboard from "@/pages/CrewDashboard";
import About from "@/pages/About";
import CrewCode from "@/pages/CrewCode";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<RegisterParticipant />} />
          <Route path="/about" element={<About />} />
          <Route path="/crew-dos-and-donts" element={<CrewCode />} />
          <Route path="/crew-code" element={<Navigate to="/crew-dos-and-donts" replace />} />
          <Route path="/event/:id" element={<EventDetails />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/crew/login" element={<CrewLogin />} />
          <Route path="/crew/dashboard" element={<CrewDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
      <PWAInstallPrompt />
    </div>
  );
}

export default App;
